// Imports
import ReactDOM from 'react-dom/client';
import { Provider } from 'react-redux';
import App from './components/app';
import ErrorBoundary from './components/resources/error-boundary';
import store from './shareables/foundation/front-end/redux/store';
import setUp from './shareables/foundation/front-end/utils/set-up';
import { Settings } from 'luxon';
import 'react-loading-skeleton/dist/skeleton.css';


// Set up
setUp();


// Fall back to U.S. English when the browser reports no locale
if (!new Intl.DateTimeFormat().resolvedOptions().locale) {
	Settings.defaultLocale = 'en-US';
}


// Create root
const container = document.getElementById('root');

if (!container) {
	throw new Error('Root container should exist');
}

const root = ReactDOM.createRoot(container);


// Mount & render
root.render(
	<ErrorBoundary>
		<Provider store={store}>
			<App />
		</Provider>
	</ErrorBoundary>
);
